exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/modules/_wks-ext.js
// module id = 2jPN
// module chunks = 0